import React from 'react';
import Helmet from 'react-helmet';
import { AMBIENTE_ATUAL, IS_CORDOVA } from 'constants/constants';

const Headers = (): JSX.Element => {
  return (
    <div>
      <Helmet>
        <title>Voalá - Menos destino, mais viagem</title>
        <meta property="og:type" content="article" />
        <meta property="og:title" content="..pensou, pesquisou, VOALÁ" />
        <meta property="og:description" content="Você tem um Brasil para viajar!" />
        <meta
          property="og:image"
          content="https://www.bancorbras.com.br/repositorio//imagem/612/61273b53a676d5e9fbe24750446beb99.png"
        />
        {/* <!-- TrustBox script -->  */}
        <script
          type="text/javascript"
          src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async
        />
        {/* <!-- End TrustBox script --> */}



        {/* Google Tag Manager 
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-TP7LZV2');`}
        </script>
         End Google Tag Manager */}

        {/* Google Tag Manager (noscript) */}
        <noscript>
          {`
              <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TP7LZV2"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
            `}
        </noscript>
        {/* End Google Tag Manager (noscript) */}


      </Helmet>

      {/** Apenas para testes! Ao subir para a produção, colocar aqui a condição para production: AMBIENTE_ATUAL === 'production' */}
      {!IS_CORDOVA && (
        <Helmet>
          {/* Google Analytcs */}
          <script
            async
            src="https://googletagmanager.com/gtag/js?id=UA-120916621-1"
          />
          <script>
            {`
              function gtag(){dataLayer.push(arguments); }
              gtag('js', new Date());

              gtag('config', 'UA-120916621-1');
            `}
          </script>
          {/* end Google Analytcs */}

          {/* Google Ads (Global site tag (gtag.js)) GRUUV */}
          <script async src="https://googletagmanager.com/gtag/js?id=AW-769589890" />
          <script>
            {`
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', 'AW-769589890');
            `}
          </script>
          {/* end Google Ads */}



          {/* Sdk hotJar */}
          <script>
            {`
              (function(h,o,t,j,a,r){
                h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
                h._hjSettings={hjid: 1461329,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `}
          </script>
          {/* end hotJar */}


          {/* facebook pixel */}
          <script>
            {`
						!function(f,b,e,v,n,t,s)
      			{if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
							n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
						if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
						n.queue=[];t=b.createElement(e);t.async=!0;
						t.src=v;s=b.getElementsByTagName(e)[0];
						s.parentNode.insertBefore(t,s)}(window,document,'script',
						'https://connect.facebook.net/en_US/fbevents.js');
						fbq('init', '1564019177063624');
						fbq('track', 'PageView');
					`}
          </script>
          <noscript>
            {`
            <img height="1" width="1" src="https://www.facebook.com/tr?id=1564019177063624&ev=PageView&noscript=1" />
          `}
          </noscript>
          {/* end facebook pixel */}
        </Helmet>
      )}
      {AMBIENTE_ATUAL === 'production' && IS_CORDOVA && (
        <Helmet>
          {/* Google Analytcs */}
          {/* <script
            async
            src="https://googletagmanager.com/gtag/js?id=UA-120916621-1"
          />
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments); }
              gtag('js', new Date());

              gtag('config', 'UA-120916621-1');
            `}
          </script> */}
          {/* end Google Analytcs */}

          {/* Google Ads (Global site tag (gtag.js)) GRUUV */}
          {/* <script async src="https://googletagmanager.com/gtag/js?id=AW-769589890" />
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', 'AW-769589890');
            `}
          </script> */}
          {/* end Google Ads */}





          {/* facebook pixel */}
          {/* <script>
            {`
						!function(f,b,e,v,n,t,s)
      			{if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
							n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
						if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
						n.queue=[];t=b.createElement(e);t.async=!0;
						t.src=v;s=b.getElementsByTagName(e)[0];
						s.parentNode.insertBefore(t,s)}(window,document,'script',
						'https://connect.facebook.net/en_US/fbevents.js');
						fbq('init', '1564019177063624');
						fbq('track', 'PageView');
					`}
          </script> */}
          {/* <noscript>
            {`
            <img height="1" width="1" src="https://www.facebook.com/tr?id=1564019177063624&ev=PageView&noscript=1" />
          `}
          </noscript> */}
          {/* end facebook pixel */}
        </Helmet>
      )}
    </div>
  );
};

export default Headers;
